/* unplugin-vue-components disabled */import { render } from "./about.vue?vue&type=template&id=2bec83f8&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=2bec83f8&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/zhishiOfficialweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bec83f8"]])

export default __exports__